<template>
  <div ref="photoViewer">
    <b-img
      :key="index"
      :src="photo.url"
      style="width: 85px; height: 85px; cursor: pointer;"
      v-for="(photo, index) in photos"
    ></b-img>
  </div>
</template>

<script>
import Vue from 'vue'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
import { ImagePlugin } from 'bootstrap-vue'

Vue.use(ImagePlugin)

export default {
  name: 'photo-viewer',
  props: {
    photos: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      viewer: null
    }
  },
  mounted() {
    if (this.photos.length > 0) {
      this.createPhotoViewer()
    }
  },
  watch: {
    photos(new_photos) {
      if (new_photos.length > 0) {
        if (this.viewer) {
          this.viewer.destroy()
        }
        this.$nextTick(() => {
          this.createPhotoViewer()
        });
      }
    }
  },
  beforeDestroy() {
    if (this.viewer) {
      this.viewer.destroy()
    }
  },
  methods: {
    createPhotoViewer() {
      this.viewer = new Viewer(this.$refs.photoViewer, {
        movable: false,
        toolbar: {
          zoomIn: { show: 2, size: 'medium' },
          prev: { show: 1, size: 'large' },
          play: { show: 1, size: 'large' },
          reset: { show: 1, size: 'large' },
          next: { show: 1, size: 'large' },
          zoomOut: { show: 2, size: 'medium' },
          oneToOne: 0,
          rotateLeft: 0,
          rotateRight: 0,
          flipHorizontal: 0,
          flipVertical: 0
        }
      });
    }
  }
};
</script>